import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { waSupportLink } from "@/lib/support";

// Floating "Chat on WhatsApp" support button, visible on every customer page.
// On a ticket page it pre-fills the message with the ticket reference from the URL.
export const WhatsAppSupport = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  let msg = "Hello B&B KIGALI support, I need help.";
  const m = pathname.match(/\/ticket\/([^/]+)/);
  if (m) msg = `Hello B&B KIGALI support, I need help with my ticket (ref: ${m[1]}).`;
  else if (pathname.startsWith("/my-tickets")) msg = "Hello B&B KIGALI support, I need help with my tickets.";
  else if (pathname.startsWith("/events")) msg = "Hello B&B KIGALI support, I have a question about an event / my order.";

  return (
    <a href={waSupportLink(msg)} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-support-btn"
      aria-label="Chat with support on WhatsApp"
      className="fixed right-4 bottom-28 z-[60] flex items-center gap-2 h-12 pl-3 pr-4 rounded-full bg-[#25D366] text-white font-bold shadow-lg shadow-black/40 hover:bg-[#1EBE5A] transition-colors">
      <MessageCircle className="w-5 h-5" />
      <span className="hidden sm:inline text-sm">Chat with us</span>
    </a>
  );
};
